import projectConfig from '@/config/config';
const baseURL = projectConfig.baseURL;
const api = {
  // 待上传列表
  uploadList: baseURL + '/trade/contract/scan/upload/queryUploadContractPage',
  //H5上传司机证照
  inOutCaruploadPic: baseURL + '/trade/inOutCar/uploadPic',
  //进厂车辆登记-获取下一条记录
  inOutCarQueryNextDetail: baseURL + '/trade/inOutCar/queryNextDetail',
  //进厂车辆登记-获取详情
  inOutCarQueryDetail: baseURL + '/trade/inOutCar/detail',
  // 采购/销售合同获取上传合同详情
  queryUploadContractDetail: baseURL + '/trade/contract/scan/upload/queryUploadContractDetail',
  //采购/销售合同-获取下一条待上传合同
  queryNextUploadContractDetail: baseURL + '/trade/contract/scan/upload/queryNextUploadContractDetail',
  //采购/销售-上传合同图片
  updateContractPic: baseURL + '/trade/contract/scan/upload/updateContractPic',
  //进项发票-图片查询
  purchaseInvoiceQueryPicture: baseURL + '/trade/purchaseInvoice/query/picture',
  //进项发票-图片更新
  purchaseInvoiceUpdatePicture: baseURL + '/trade/purchaseInvoice/update/picture',
  //进项发票-下一个缺失图片
  purchaseInvoiceNextMissPicture: baseURL + '/trade/purchaseInvoice/next/miss/picture',
  //销项发票-图片查询
  saleInvoiceQueryPicture: baseURL + '/trade/saleInvoice/query/picture',
  //销项发票-图片更新
  saleInvoiceUpdatePicture: baseURL + '/trade/saleInvoice/update/picture',
  //销项发票-下一个缺失图片
  saleInvoiceNextMissPicture: baseURL + '/trade/saleInvoice/next/miss/picture',
  //供应商图片查询
  supplierQueryPicture: baseURL + '/trade/supplier/query/picture',
  //供应商-图片更新
  supplierUpdatePicture: baseURL + '/trade/supplier/update/picture',
  //供应商-下一个缺失图片
  supplierNextMissPicture: baseURL + '/trade/supplier/next/miss/picture',
  //采购商-图片查询
  customerQueryPicture: baseURL + '/trade/customer/query/picture',
  //采购商-更新图片
  customerUpdatePicture: baseURL + '/trade/customer/update/picture',
  //采购商-下一个缺失图片
  customerNextMissPicture: baseURL + '/trade/customer/next/miss/picture',
  //物流管理-图片查询
  enterpriseTrackManagerQueryPicture: baseURL + '/trade/trackManager/query/picture',
  //物流管理-图片更新
  enterpriseTrackManagerUpdatePicture: baseURL + '/trade/trackManager/update/picture',
  //物流管理-下一个缺失图片
  enterpriseTrackManagerNextMissPicture: baseURL + '/trade/trackManager/next/miss/picture'
};

export default api;
